import { Component, input, signal } from '@angular/core';
import { CurrencyFormatPipe } from '@webapp/core/pipes/currencyFormat';
import { RecommendedBadgeComponent } from '@webapp/core/ui/components/recommended-badge/recommended-badge.component';
import { CoveragePriceComponent } from '@webapp/core/ui/components/coverage-price/coverage-price.component';
import { ICoverage } from '@webapp/payments';



@Component({
  selector: 'app-quoter-sidebar-coverage',
  imports: [RecommendedBadgeComponent, CurrencyFormatPipe, CoveragePriceComponent],
  templateUrl: './quoter-sidebar-coverage.component.html',
  styleUrl: './quoter-sidebar-coverage.component.scss',
})
export class QuoterSidebarCoverageComponent {
  coverage = input<ICoverage>();
  currency = input<string>();


  isDetailOpen = signal(false);
  toggleDetailOpen() {
    this.isDetailOpen.set(!this.isDetailOpen());
  }
}
